import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from "react";
import FeedbackModal from "../ui/feedback/FeedbackModal";

interface FeedbackModalContextType {
  open: () => void;
  close: () => void;
}

const FeedbackModalContext = createContext<
  FeedbackModalContextType | undefined
>(undefined);

export function useFeedbackModal() {
  const ctx = useContext(FeedbackModalContext);
  if (!ctx)
    throw new Error(
      "useFeedbackModal must be used within a FeedbackModalProvider"
    );
  return ctx;
}

export function FeedbackModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  return (
    <FeedbackModalContext.Provider value={{ open, close }}>
      {children}
      {isOpen && <FeedbackModal onClose={close} />}
    </FeedbackModalContext.Provider>
  );
}
